// eslint-disable-next-line no-use-before-define
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  titleContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  title: {
    ...theme.typography.h5,
    color: theme.palette.text.primary.main,
  },
}));

/**
 * Shared title component for compensation periods.
 * Eliminates duplication between pharmacy and oriolaAdmin components.
 */
function CompensationTitle() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.titleContainer}>
      <Typography className={classes.title}>
        {t("compensationPeriods")}
      </Typography>
    </div>
  );
}

export default CompensationTitle;
